import CategoriaProductoService from 'src/modules/categoriaProducto/categoriaProductoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'CATEGORIAPRODUCTO_VIEW';

const categoriaProductoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaProductoViewActions.FIND_STARTED,
      });

      const record = await CategoriaProductoService.find(id);

      dispatch({
        type: categoriaProductoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: categoriaProductoViewActions.FIND_ERROR,
      });

      getHistory().push('/categoria-producto');
    }
  },
};

export default categoriaProductoViewActions;
